export const allFoldersInSharedMailbox = "edYyNd";
export const allFoldersInPstFile = "ikFWD";
export const allPstFiles = "bjLa7d";
export default {allFoldersInSharedMailbox,allFoldersInPstFile,allPstFiles};